export default {
  'AssetsManage': {
    portfolio: 'Portfolio',
    trade: 'Trade',
    portfolio_value_1: 'Total Value',
    portfolio_value_3: 'In Order',
  },
  'BTC Value': 'BTC Value',
  'Hide Small Balances': 'Hide Small Balances',
  'Search Coin Name': 'Search Coin Name',
  'asset.overview': 'Overview',
  'My Asset': 'My Asset',
  'Balances': 'Balances',

  'ExchangeManage': {
    title: 'Activities',
    tab_1: 'open-order',
    tab_2: 'order-history',
  },
  'certification': {
    title: 'Identity Verification',
    url: 'Security Center',
    tab_1: 'Fill in personal info',
    tab_2: 'Upload documents',
    tab_3: 'Upload handheld photo',
    fill: 'Fill in personal data',
    notes: 'Notes',
    notes_1: 'Make sure that your first and last name are spelled exactly as written in your identity document',
    notes_2: 'Double check your ID number prior to entering, as it will be verified in the next step',
    notes_3: 'Make sure your name and ID number are clearly visible on the photo',
    notes_4: '',
    id: 'Your Biconomy Account ID is:',
    use: 'Use a blank sheet of paper, black pen and write legibly so that the information is clearly visible',
    tips: 'Click to upload the photos of the front page of your identity document in PNG or JPEG format.',
    notes_5: 'Write a note (Date, Name, Biconomy ID)',
    notes_6: 'Hold your ID and your note',
    notes_7: 'Note: Hold both in your hand, example pictures as above',
  },
  'date_time': 'DATE TIME',
  'ip.address': 'Ip Address',
  'assets': 'Assets',
  "spot_account": "Spot",

  // 侧边栏
  'Profile': 'Profile',
  'Identification': 'Identification',
  'Recently logged In': 'Recently logged In',

  // Profile
  'Account Risk Level': 'Account Risk Level',
  'level.high': 'High',
  'level.medium': 'Medium',
  'level.low': 'Low',
  'Institutional Verification': 'Institutional Verification',
  'Identification.desc': 'No withdrawals until verification is completed',
  'Verify Now': 'Verify Now',
  'referral.desc': 'Up to 20% Rebates with Our Referral Program',
  'More Details': 'More Details',
  'security.desc': 'To protect your account, it is recommended to turn on at least one 2FA',
  'Security Recommendations': 'Security Recommendations',
  'api.desc': 'Create an API key',
  'Manage': 'Manage',
  'switch_personal_verification': 'Switch to personal verification',
  'switch_institutional_verification': 'Switch to institutional verification',

  // security-center
  'Email Verification': 'Email Verification',
  'email_verification_desc': 'Link your email address to your account for password recovery and withdrawal confirmation.',
  'OFF': 'OFF',
  'On': 'On',
  'change_modify': 'Change',
  'common_cancel': 'Cancel',
  'email_change_title': 'Are you sure you want to change Email Verification ?',
  'email_change_tip1': 'Log in is required after changing your email address.',
  'email_change_tip2': 'For your security, withdrawals from your account will be disabled for 24 hours once your email address is changed.',
  'email_change_tip3':
    'In order to change your registered email address, you must enable Google Authentication or Phone Verification (2FA).',
  'Continue': 'Continue',
  'New Email Address': 'New Email Address',
  'New Email Verification Code': 'New Email Verification Code',
  'Bind Successfully': 'Bind Successfully',
  'Change Successfully': 'Change Successfully',
  'enter_new_email': 'Enter New Email Address',
  'enter_new_email_code': 'Enter New Email Verification Code',
  'Change Email Address': 'Change Email Address',

  'Phone Verification': 'Phone Verification',
  'phone_verification_desc': 'Link your phone number to your account to receive verification codes via SMS.',
  'phone_change_title': 'Are you sure you want to change Phone Verification ?',
  'phone_change_tip1': 'Log in is required after changing your Phone number.',
  'phone_change_tip2': 'For your security, withdrawals from your account will be disabled for 24 hours once your phone number is changed.',
  'phone_change_tip3':
    'In order to change your registered phone number, you must enable Google Authentication or Email Verification (2FA).',
  'New Phone Number': 'New Phone Number',
  'New Phone Verification Code': 'New Phone Verification Code',
  'Change Phone Number': 'Change Phone Number',

  'Google Verification': 'Google Verification',
  'google_verification_desc':
    'Set up your Google Authenticator to provide an extra layer of security when withdrawing funds or configuring your security settings.',
  'google_change_title': 'Are you sure you want to change Google Authentication ?',
  'google_change_tip':
    'Withdrawals and P2P transactions will be disabled for 24 hours after changing Google Authenticator to ensure the safety of your accounts.',

  'Login Password': 'Login Password',
  'login_password_desc': 'Increase your password strength to enhance account security.',
  'Important': 'Important',
  'password_change_tip': 'For security purposes, no withdrawals are permitted for 24 hours after modification of security methods.',
  'Change Password': 'Change Password',
  'Enter old password': 'Enter old password',
  'Enter new password': 'Enter new password',
  'Confirm new password': 'Confirm new password',

  'fund_pw_desc': 'Fund password is used as a means for double-verification when withdrawing currencies from your accounts',
  'fund_pw_set_tip':
    'For security purposes, no withdrawals are permitted within 24 hours after setting the fund password for the first time.',
  'fund_pw_change_tip': 'For security purposes, no withdrawals are permitted for 24 hours after modification of fund password.',
  'Confirm new Fund password': 'Confirm new fund password',
  'New Fund Password': 'New Fund Password',
  'Change Fund Password': 'Change Fund Password',

  // google bind
  'Google Authentication': 'Google Authentication',
  'Copy Key': 'Copy Key',
  'google_key_desc': 'Copy key and add to Google Authenticator',
  'google_key_tip':
    'Please save this Backup Key in a secure location.This Key will allow you to recover your Authenticator should you lose your Phone.Otherwise, resetting your Authenticator will take at least 7 days.',

  // 登录历史
  'login time': 'login time',
  'login device': 'login device',

  // 认证'
  'certification.title_1': 'Fill In Personal Info',
  'ID Card': 'ID Card',
  'Passport': 'Passport',
  'certification.type': 'ID Type',
  'Enter Last Name': 'Enter Last Name',
  'Enter First Name': 'Enter First Name',
  'Enter your ID number': 'Enter your ID number',
  'certification.title_2': 'Upload Your Identity Document',
  'certification.upload_tip': 'Make sure your name and ID number are clearly visible on the photo',
  'certificate.front_tip': 'Upload the photos of the front page of your identity document in PNG or JPEG format.',
  'certificate.inhand_tip': 'Upload the back page of your ID card in PNG or JPEG format.',
  'certificate.passport.pic': 'Passport photo on the front',
  'certificate.passport_tip': 'Upload the photos of the front page of your passport in PNG or JPEG format.',
  'Image format error': 'Image format error',
  'Submitted successfully': 'Submitted successfully',
  'certification.success_tip1': 'Primary KYC submitted successfully.',
  'certification.success_tip2': 'Verification is expected to be completed within 1-2 business days.Thank you for your understanding!',
  'Got It': 'Got It',
  'certification.review_title': 'Primary KYC Under Review',
  'certification.review_tip1': 'Primary KYC submitted successfully.',
  'certification.review_tip2': 'Verification is expected to be completed within 1-2 business days.Thank you for your understanding!',
  'Verification Failed': 'Verification Failed',
  'Verify Again': 'Verify Again',
  'Fill In Business Info': 'Fill In Business Info',
  'Enter Your Entity Name': 'Enter Your Entity Name',
  'Enter your Registration Number': 'Enter your Registration Number',
  'enter the nature of business': 'enter the nature of business',
  'Upload Business Licence': 'Upload Business Licence',
  'certification.Business_upload_tip': 'Make sure your Business name, number and address are clearly visible on the photo',
  'certification.Business_img_tip': 'Click to upload your business license in PDF, PNG or JPEG format.',

  // 钓鱼码
  'Anti-Phishing Code': 'Anti-Phishing Code',
  'anti_phishing_desc': 'Emails sent will contain your anti-phishing code to protect against phishing attacks.',
  'anti_phishing_question1': 'What is an anti-phishing code?',
  'anti_phishing_answer1':
    'An anti-phishing code is a string of characters that you can set to help distinguish between the genuine and fraudulent Biconomy website.',
  'anti_phishing_question2': 'Where will the anti-phishing code appear?',
  'anti_phishing_answer2.1':
    'Once you have set your anti-phishing code, all official email correspondences from Biconomy should contain an image of your anti-phishing code.',
  'anti_phishing_answer2.2': 'If the code in the email does not match your actual code, you may be the target of malicious activity.',
  'anti_phishing_set': 'Set Anti-Phishing Code',
  'anti_phishing_tip1': "Please don't tell anyone your password, Google or Verification codes, including Biconomy Support.",
  'anti_phishing_create': 'Create Anti-Phishing Code',
  'anti_phishing_tip2': 'Please enter 1 to 6 alphanumeric characters. Do not use commonly used passwords.',
  'anti_phishing_old': 'Old Anti-Phishing Code',
  'anti_phishing_change': 'Change Anti-Phishing Code',
  'anti_phishing_new': 'New Anti-Phishing Code',
  'anti_phishing_set_placeholder': 'Please Set Your Anti-Phishing Code',
  'anti_phishing_enter_placeholder': 'Please Enter Your Anti-Phishing Code',
  'Setup successfully': 'Setup successfully',

  // 账号管理
  'Manage Account': 'Manage Account',
  'manage_account_desc': 'Disable or delete your account immediately.',
  'Disable Account': 'Disable Account',
  'disable_account_desc':
    'Once the account is disabled, most of your actions will be restricted, such as logging in, trading, etc. But you can choose to unblock the account. ',
  'Delete Account': 'Delete Account',
  'delete_account_desc':
    'Once the account is deleted, the data of this account will be cleared such as: mobile phone, email, identity verification, etc.And this behayior is irreversible.',
  'disable_account_reason_title': 'The reason you want to disable your account',
  'delete_account_reason_title': 'The reason you want to delete your account',
  'Please specify the reason': 'Please specify the reason',
  'Other reasons': 'Other reasons',
  'disable_account_reason_1': 'My email account was leaked and I want to temporarily disable it.',
  'disable_account_reason_2': 'I never want to use the account again.',
  'disable_account_reason_3': 'I already use an account from another platform.',
  'delete_account_reason_2': 'I want to close the account and register another Biconomy account.',
  'delete_account_reason_3': 'Phone number and email account registered separately, now want to merge the account.',
  'disable_account_third_step_title': 'Disabling your account will cause the following',
  'delete_account_third_step_title': 'Delete your account will cause the following',
  'disable_account_warning_1': 'All pending withdrawals will be canceled.',
  'disable_account_warning_2': 'All trading capacities for your account will be disabled.',
  'disable_account_warning_3': 'All API keys for your account will be deleted.',
  'disable_account_warning_4': 'All devices for your account will be deleted.',
  'disable_account_warning_5': 'In order to reactivate your account, you will need to contact Biconomy support.',
  'disable_account_warning_6': 'Verified personal information will not be deleted.',
  'delete_account_warning_1': 'The account is not located in restricted countries.',
  'delete_account_warning_2': 'The total balance is less than 0.001 BTC.',
  'delete_account_warning_3': 'Loan=0',
  'disable_account_check_1': 'I understand the consequences of disabling an account.',
  'disable_account_check_2': 'I understand that after disabling account, my asset balance {balance} will not be able to be withdraw.',
  'delete_account_check_1': 'I understand the consequences of deleting an account.',
  'delete_account_check_2': 'I understand that after deleting my account, my asset balance {balance} will not be able to be retrieved.',
  'disable_account_tip': 'If you failed to reactivate your account, please contact customer service.',
  'delete_account_tip1':
    'To ensure your account’s security and protect your assets, account deletion request will be reviewed by Biconomy carefully before deletion.',
  'delete_account_tip2': 'To initiate the account deletion request, please contact Customer Support.',
  'Risk Warning': 'Risk Warning',
  'delete_account_modal_desc':
    'After deleting account, you will not be able to re-register, please make sure you fully understand the consequences before submitting a request to delete your account.',
  'Disabled Successfully': 'Disabled Successfully',
};
